import { useEffect, useRef, useState } from 'react';
import Styles from './index.module.css';

export default function StandardIconDropDown({ iconClass, label, options = [], onSelect }) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleMenu = (e) => {
        e.stopPropagation();
        setIsOpen(prev => !prev);
    };

    const handleSelect = (e, item) => {
        e.stopPropagation(); // Prevents toggleMenu from triggering again
        setIsOpen(false);
        onSelect?.(item.value);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div
            className={Styles.iconItem}
            onClick={toggleMenu}
            ref={dropdownRef}
            style={{ position: 'relative', cursor: 'pointer' }}
        >
            <i className={iconClass}></i>
            <p>{label}</p>

            {isOpen && (
                <div className={Styles.dropdownMenu}>
                    {options.map((item, index) => (
                        <div
                            key={index}
                            className={Styles.dropdownItem}
                            onClick={(e) => handleSelect(e, item)}
                        >
                            {item.text}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
